import {getMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/proxy/searchVisa', request, cancelToken)
}

export {get}
